import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { useFeatureFlags } from '@/features/feature-flags/hooks/use-feature-flags';

import { ChartLine } from 'lucide-react';

export const RateChartMoved = () => {
	const { flags } = useFeatureFlags();

	const rateChartMovedFlag = flags?.rateChartMovedNotice?.enabled || false;

	if (!rateChartMovedFlag) {
		return null;
	}

	return (
		<Alert className='tw-mb-4 tw-mt-4'>
			<ChartLine className='tw-size-4' />
			<AlertTitle>Rate Chart Has Moved</AlertTitle>
			<AlertDescription>
				The rate chart has moved to the Rates tab.
			</AlertDescription>
		</Alert>
	);
};
